var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _ellipse, _path13, _ellipse2, _ellipse3, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTowingVehicle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249.965,
    height: 122.066,
    viewBox: "0 0 249.965 122.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1023.408 -740.567)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1078.5,778.637h0a4.406,4.406,0,0,1-4.393-4.393V763.731a4.406,4.406,0,0,1,4.393-4.392h0a4.4,4.4,0,0,1,4.392,4.392v10.513A4.405,4.405,0,0,1,1078.5,778.637Z",
    transform: "translate(-10.723 -3.97)",
    fill: "#f01067"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.766,839.142l-6.475-10.091-29.505,7.313-26.752,19.11h-1.153a3.683,3.683,0,0,0-3.629,3.735h0a3.684,3.684,0,0,0,3.6,3.734l32.041.242s1.549-19.373,27.814-16.583a3.749,3.749,0,0,0,4.057-3.812Z",
    transform: "translate(-0.601 -18.713)",
    fill: "#26242d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.989,852.168H1029.4c-4,.054-1.648-36.231.128-37.946l36.051-.551Z",
    transform: "translate(-0.804 -15.46)",
    fill: "#8f09f9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.862,835.97s-27.919-6.4-36.98,15.9l-.347-37.82h37.473Z",
    transform: "translate(-8.698 -15.541)",
    fill: "#8f09f9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.879,854.671h0a2.886,2.886,0,0,1-2.886-2.886v-3.764a2.886,2.886,0,0,1,2.886-2.886h0a2.886,2.886,0,0,1,2.887,2.886v3.764A2.886,2.886,0,0,1,1032.879,854.671Z",
    transform: "translate(-1.393 -22.114)",
    fill: "#f7fefb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.539,807.23a1.151,1.151,0,0,0,1.157-1.15h0V778.43a7.279,7.279,0,0,0-7.279-7.279h-36.264a5.584,5.584,0,0,0-4.958,3.016l-16.072,31.057a1.151,1.151,0,0,0,1.028,1.675Z",
    transform: "translate(-1.393 -6.468)",
    fill: "#8f09f9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.2,806.417h0a2.32,2.32,0,0,1-2.313-2.313V793.632a2.32,2.32,0,0,1,2.313-2.313h0a2.32,2.32,0,0,1,2.313,2.313V804.1A2.32,2.32,0,0,1,1035.2,806.417Z",
    transform: "translate(-2.005 -10.733)",
    fill: "#26242d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.9,784.572h-18.012a3,3,0,0,0-3,3v4.868h1.273v-3.48a3,3,0,0,1,3-3h16.74Z",
    transform: "translate(-2.005 -9.306)",
    fill: "#26242d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.083,784.512l25.379-.7a3.645,3.645,0,0,1,3.83,3.683l-.353,9.819a3.581,3.581,0,0,1-2.454,3.227l-33.5,11.608a3.854,3.854,0,0,1-3.775-.714l-.2-.177a3.456,3.456,0,0,1-.948-3.969l8.676-20.553A3.723,3.723,0,0,1,1052.083,784.512Z",
    transform: "translate(-3.464 -9.146)",
    fill: "#26242d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.9,828.051h-8.53a1.87,1.87,0,0,1-1.865-1.865h0a1.87,1.87,0,0,1,1.865-1.865h8.53a1.871,1.871,0,0,1,1.865,1.865h0A1.871,1.871,0,0,1,1084.9,828.051Z",
    transform: "translate(-10.807 -17.712)",
    fill: "#26242d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.864,847.34h-3.022a.9.9,0,0,1-.9-.9h0a.9.9,0,0,1,.9-.9h3.022a.9.9,0,0,1,.9.9h0A.9.9,0,0,1,1088.864,847.34Z",
    transform: "translate(-13.013 -22.199)",
    fill: "#f7fefb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.772,
    height: 2.614,
    rx: 1.307,
    transform: "translate(1028.6 815.919)",
    fill: "#f7fefb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.213,872.309H1074.081l-3.46-9.917h43.353l145.813-.376v2.719A7.575,7.575,0,0,1,1252.213,872.309Z",
    transform: "translate(-9.985 -25.684)",
    fill: "#26242d"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.723,
    cy: 16.989,
    rx: 17.723,
    ry: 16.989,
    transform: "matrix(1, -0.022, 0.022, 1, 1060.258, 827.488)",
    fill: "#26242d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.618,869.5a10.639,10.639,0,1,0,10.4-10.426A10.417,10.417,0,0,0,1079.618,869.5Z",
    transform: "translate(-11.887 -25.063)",
    fill: "#f7fefb"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.433,
    cy: 6.166,
    rx: 6.433,
    ry: 6.166,
    transform: "translate(1071.79 838.054) rotate(-1.285)",
    fill: "#26242d"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.723,
    cy: 16.989,
    rx: 17.723,
    ry: 16.989,
    transform: "translate(1190.572 827.488) rotate(-1.289)",
    fill: "#26242d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.883,869.5a10.639,10.639,0,1,0,10.4-10.426A10.416,10.416,0,0,0,1244.883,869.5Z",
    transform: "translate(-46.838 -25.063)",
    fill: "#f7fefb"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1250.2,870.326a6.439,6.439,0,1,0,6.293-6.309A6.3,6.3,0,0,0,1250.2,870.326Z",
    transform: "translate(-47.963 -26.107)",
    fill: "#26242d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.7,865.949H1115.448V854.1l171.255,3.451Z",
    transform: "translate(-19.465 -24.009)",
    fill: "#26242d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1288.7,855.978l-26.531-7.116a28.467,28.467,0,0,0-7.374-.971H1120.931a5.483,5.483,0,0,0-5.483,5.483v2.384h134.884a28.474,28.474,0,0,1,6.451.74l31.374,7.3a3.314,3.314,0,0,0,4.065-3.228h0A5.03,5.03,0,0,0,1288.7,855.978Z",
    transform: "translate(-19.465 -22.697)",
    fill: "#8f09f9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.787,758.505h0a1,1,0,0,1-1.415-.032l-6.167-6.448a1,1,0,0,1,.031-1.416h0a1,1,0,0,1,1.415.032l6.167,6.448A1,1,0,0,1,1068.787,758.505Z",
    transform: "translate(-7.935 -2.065)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.107,758.505h0a1,1,0,0,0,1.415-.032l6.166-6.448a1,1,0,0,0-.031-1.416h0a1,1,0,0,0-1.415.032l-6.167,6.448A1,1,0,0,0,1089.107,758.505Z",
    transform: "translate(-13.829 -2.065)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.956,751.491h0a1,1,0,0,0,1-1l.01-8.922a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1l-.01,8.922A1,1,0,0,0,1078.956,751.491Z",
    transform: "translate(-11.536)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1098.113 758.298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1121.176,824.329l3.221,4.569a6.8,6.8,0,0,0,5.492,2.883l128.555-.4,10.083-.035a6.735,6.735,0,0,0,5.52-3.262l1.7-2.395L1253.218,808.4l-77.165-4.275-48.6,7.116Z",
    transform: "translate(-1118.789 -771.74)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.11,817.005a16.516,16.516,0,0,0,1.456-3.909,16.16,16.16,0,0,0,.217-2.989,5.8,5.8,0,0,0-2.566-4.807h0s.93-9.558-.665-13.022c0,0,.166-.412.372-1.042a7.686,7.686,0,0,0-1.559-7.477l-4.161-4.7c-7.182-8.114-9.448-11.795-20.169-13.369-16.214-2.381-47.756-4.983-62.249,1.2-12.98,5.535-19.893,8.966-24.93,11.881-2.56,1.482-7.359,4.466-10.125,5.486-2.283.842-5.8,1.165-8.187,1.691-5.7,1.26-9.669,1.767-15.01,3.988a19.5,19.5,0,0,0-4.886,2.919,12.721,12.721,0,0,0-4.493,10.315l.315,10.666a3.863,3.863,0,0,0,3.8,3.733Z",
    transform: "translate(-1118.149 -763.054)",
    fill: "#15b9e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.829,791.769c2.3-.922,5.265-1.7,7.517-.846a3.453,3.453,0,0,1,2.146,3.623q-.007.066-.016.132a3.365,3.365,0,0,1-3.424,2.865l-5.491-.119a2.61,2.61,0,0,1-1.995-1h0A3.013,3.013,0,0,1,1299.829,791.769Z",
    transform: "translate(-1156.168 -768.87)",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.084,805.446c.982-1.853,3.538-4.752,10.155-6.426a1.124,1.124,0,0,1,1.12,1.833c-.321.36-.649.73-.965,1.084a17.891,17.891,0,0,1-5.586,4.235,15.1,15.1,0,0,1-3.283,1.214A1.336,1.336,0,0,1,1124.084,805.446Z",
    transform: "translate(-1119.37 -770.652)",
    fill: "#f7fefb",
    stroke: "#f7fefb",
    strokeMiterlimit: 10,
    strokeWidth: 0.937
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.077,771.51c-4.335-1.431-22.45-1.851-22.45-1.851a3.839,3.839,0,0,0-4.109,3.209l-1.814,11.222a3.833,3.833,0,0,0,3.8,4.445l17.235-.057c4.148-.013,8.11-3.452,10.43-6.892.054-.08.107-.161.16-.243C1281.495,777.992,1279.869,772.761,1276.077,771.51Z",
    transform: "translate(-1145.537 -764.448)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.2,768.472a85.008,85.008,0,0,0-47.606,15.726,2.436,2.436,0,0,0,1.432,4.419l44.16-.3a4.04,4.04,0,0,0,3.952-3.342l2.063-11.762A4.037,4.037,0,0,0,1224.2,768.472Z",
    transform: "translate(-1130.292 -764.2)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.457,787.348c-.175-1.907,6.027-6.914,10.712-4.947,1.842.967,2.366,5.245-2.388,6.2C1189.605,789.447,1185.632,789.253,1185.457,787.348Z",
    transform: "translate(-1132.383 -767.05)",
    fill: "#15b9e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.976,800.983l8.895-.031a1.335,1.335,0,0,0,1.327-1.336h0a1.336,1.336,0,0,0-1.336-1.328l-8.894.03a1.337,1.337,0,0,0-1.328,1.336h0A1.336,1.336,0,0,0,1212.976,800.983Z",
    transform: "translate(-1137.921 -770.505)",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.263,800.84l8.895-.03a1.335,1.335,0,0,0,1.327-1.336h0a1.335,1.335,0,0,0-1.336-1.327l-8.894.03a1.336,1.336,0,0,0-1.328,1.337h0A1.335,1.335,0,0,0,1255.263,800.84Z",
    transform: "translate(-1146.864 -770.475)",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.365,828.05c0-.129,0-.256,0-.385.158-9.1,7.384-16.326,16.142-16.143,8.634.181,15.526,7.5,15.569,16.421Z",
    transform: "translate(-1148.225 -773.303)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.055,828.454c0-.129-.005-.255,0-.385.158-9.1,7.385-16.326,16.142-16.143,8.634.181,15.527,7.5,15.57,16.421Z",
    transform: "translate(-1122.992 -773.389)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.89,
    cy: 13.446,
    rx: 12.89,
    ry: 13.446,
    transform: "translate(114.715 66.52) rotate(-88.91)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.892,829.907a8.072,8.072,0,1,1-7.916-7.884A7.9,7.9,0,0,1,1286.892,829.907Z",
    transform: "translate(-1150.425 -775.525)",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.883,830.886a3.954,3.954,0,1,1-3.878-3.861A3.872,3.872,0,0,1,1283.883,830.886Z",
    transform: "translate(-1151.528 -776.582)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.89,
    cy: 13.446,
    rx: 12.89,
    ry: 13.446,
    transform: "translate(20.224 66.84) rotate(-88.91)",
    fill: "#26242d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.059,830.313a8.072,8.072,0,1,1-7.917-7.884A7.9,7.9,0,0,1,1167.059,830.313Z",
    transform: "translate(-1125.082 -775.61)",
    fill: "#f7fefb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.049,831.292a3.954,3.954,0,1,1-3.878-3.861A3.872,3.872,0,0,1,1164.049,831.292Z",
    transform: "translate(-1126.185 -776.668)",
    fill: "#26242d"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1025.263,894.374l246.255,0a1.855,1.855,0,0,0,1.855-1.855h0a1.855,1.855,0,0,0-1.855-1.855l-246.255,0a1.855,1.855,0,0,0-1.855,1.855h0A1.855,1.855,0,0,0,1025.263,894.374Z",
    transform: "translate(0 -31.743)",
    fill: "#ebedf2",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowingVehicle);
export default __webpack_public_path__ + "static/media/towing-vehicle.fc936e81cd658807f24d559795575299.svg";
export { ForwardRef as ReactComponent };